export default "__VITE_ASSET__DipQU$ra__"